export default __webpack_public_path__ + "static/media/Dmitri-Particle_0005_StompImpactParticle.e0b22565.png";